import { h, Component } from 'preact';
import style from './style';

var classNames = require('classnames/bind');
var cx = classNames.bind(style);

import { route } from 'preact-router';

import { apiGetRequest } from '../../../components/utils/api';
import Header from '../../../components/header';


export default class TeamManagement extends Component {
	constructor(props) {
        super(props);
        this.state = {
            
        }
    }

	render() {
		return (
			<div class={cx("home")}>
                <Header />

                <div class={cx("content")}>
                    <h2>{this.props.team.team_name} Management</h2>
                    <div class={cx("options")}>
                        <div class={cx("option-base")} onClick={() => route("/team/management/members")}>
                            <p class={cx("emoji")}>👨‍👩‍👧‍👦</p>
                            <p class={cx("name")}>Members</p>
                        </div>
                        {/* <div class={cx("option-base")} onClick={() => console.log("ya")}>
                            <p class={cx("emoji")}>💰</p>
                            <p class={cx("name")}>Payment</p>
                        </div> */}
                        <div class={cx("option-base")} onClick={() => route("/team/management/api")}>
                            <p class={cx("emoji")}>🔑</p>
                            <p class={cx("name")}>API</p>
                        </div>
                    </div>
                </div>
			</div>
		)
	}
}




// WEBPACK FOOTER //
// ./routes/teams/teamManagement/index.js